import { fontSize } from "@material-ui/system";
import { isAbsolute } from "upath";

export default () => ({
  superContainer: {
    // background: "#F9F9F9",
    padding: 30,
    fontFamily: "Open sans"
  },
  labelContainer: {
    marginTop: 16
  },
  expansionMargin: {
    marginTop: 20
  },
  imageButtonContainer: {
    marginTop: 16,
    position: "relative"
  },
  changeButton: {
    marginTop: 10,
    opacity: 1,
    height: 40,
    boxShadow: "none",
    textTransform: "capitalize"
  },
  uploadText: {
    fontSize: 16,
    marginTop: 16,
    color: "rgba(51, 51, 51, 0.75)"
  },
  imageText: {
    fontSize: 12,
    // marginTop: 9,
    color: "rgba(51, 51, 51, 0.75)"
  },
  highLightText: {
    fontSize: 16,
    fontWeight: 600
  },
  horizontalLine: {
    height: 1,
    width: "100%",
    borderBottom: "1px solid #EEEEEE",
    margin: "20px 0"
  },
  labelStyle: {
    fontSize: 12
  },
  selectField: {
    width: 360,
    marginBottom: 16,
    borderBottom: "1px solid #EEEEEE",
  },
  marginStyle: {
    marginLeft: 10,
  },
  mainContainer: {
    // display: "flex",
  },
  livePreviewContainer: {
    width: "-webkit-fill-available",
    display: "flex",
    justifyContent: "center",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      color: "#10A8DB"
    }
  },
  colorCopy: {
    fontWeight: 600,
    fontSize: 14,
    marginLeft: 6,
  },
  previewContainer: {
    position: "absolute",
    top: 115,
    left: "60%",
    transform: "scale(0.9)",
  },
  bottomMargin: {
    paddingBottom: 4
  },
  selectOptionList: {
    padding: 0,
  },
  selectOptionPaper: {
    boxShadow: "0px 0px 30px 2px rgba(0, 0, 0, 0.05) !important",
    border: "1px solid #eeeeee",
    background: "white",
    width: 330,
    maxHeight: 350
  },
  utmContainer: {
    color: "#333",
    fontSize: 16,
    lineHeight: "24px",
    background: "#F9F9F9",
    padding: "8px 12px",
    marginBottom: 14,
    wordBreak: "break-all"
  },
  copiedColor: {
    color: "#66D184"
  },
  shareText: {
    color: "rgba(51, 51, 51, 1)",
    marginBottom: 6
  },
  emailValidation: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Open sans",
  },
})